var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"bodyText":_vm.bodyText,"cancelText":"cancel","continueText":"authorize sync","enableMainAction":_vm.enableMainAction,"handleCancel":_vm.handleCancel,"handleContinue":_vm.handleContinue,"headerText":_vm.headerText,"loading":_vm.loading}},[_c('InputValidator',{attrs:{"config":{
      autofocus: true,
      label: 'Directory Name',
      name: _vm.inputName,
      placeholder: 'ex: JumpCloud',
      validate: 'max:255|uniqueNameValidation|required',
      value: _vm.directoryName,
    }},on:{"InputValidatorModel":_vm.handleValueChange}}),(_vm.kbUrl)?_c('p',{ref:"message"},[_vm._v(" "+_vm._s(_vm.messageText)+" "),_c('a',{ref:"kbUrl",attrs:{"href":_vm.kbUrl,"rel":"noopener noreferrer","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.kbLinkText)+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }